'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { css } from '@flipster/styled-system/css';
import { stack, vstack } from '@flipster/styled-system/patterns';

import BidInfo from './_bid/BidInfo';
import TopNBids from './_bid/TopNBids';
import WinnerAnnouncement from './_bid/WinnerAnnouncement';
import { SparkAuctionIdContext, sparkAuctionBunja, sparkAuctionsBunja } from './_bunja';
import AuctionIcon from './_misc/AuctionIcon';
import { AuctionDetails, AuctionTitle } from './_misc/auction';
import { PastAuctionsHorizontal, PastAuctionsVertical } from './_past-auction/past-auctions';

const SparkAuctionPage = () => {
  const { isLoadingAtom, currentAuctionIdAtom } = useBunja(sparkAuctionsBunja);
  const isLoading = useAtomValue(isLoadingAtom);
  const currentAuctionId = useAtomValue(currentAuctionIdAtom);
  return (
    <div
      className={css({
        maxW: 960,
        mx: 'auto',
        pt: { base: 24, tablet: 90 },
        pb: { base: 50, tablet: 150 },
        px: { base: 16, smallDesktop: 0 },
        color: 'content.default.level-4',
      })}
    >
      <h1 className={css({ textStyle: 'Display/XL' })}>Sparks auction</h1>
      {isLoading ? null : currentAuctionId ? (
        <SparkAuctionIdContext value={currentAuctionId}>
          <CurrentAuctionPage />
        </SparkAuctionIdContext>
      ) : (
        <NoCurrentAuctionsPage />
      )}
    </div>
  );
};

export default SparkAuctionPage;

const CurrentAuctionPage = () => {
  const { auctionIsClosedAtom } = useBunja(sparkAuctionBunja);
  const auctionIsClosed = useAtomValue(auctionIsClosedAtom);
  return (
    <div>
      <h2 className={css({ mt: { base: 16, tablet: 48 }, mb: { base: 24, tablet: 40 }, textStyle: 'Display/L' })}>
        <AuctionTitle />
      </h2>
      <div className={stack({ gap: 40 })}>
        {auctionIsClosed ? <WinnerAnnouncement showGuideMessage /> : <BidInfo />}
        <AuctionDetails />
        <TopNBids />
        <PastAuctionsHorizontal />
      </div>
    </div>
  );
};

const NoCurrentAuctionsPage = () => {
  return (
    <div className={vstack()}>
      <NoCurrentAuctions />
      <PastAuctionsVertical />
    </div>
  );
};

const NoCurrentAuctions = () => {
  return (
    <div className={vstack({ my: { base: 96, tablet: 160 }, gap: 8 })}>
      <AuctionIcon size={32} />
      <p className={css({ textStyle: 'Text/M/Regular' })}>
        There are no ongoing auctions at the moment.
        <br />
        Check back for new auctions for a chance to win.
      </p>
    </div>
  );
};
